import appsIconUrl from '@/assets/admin-sidebar/apps.svg'
import modelGatewayIconUrl from '@/assets/admin-sidebar/model-gateway.svg'
import organizationIconUrl from '@/assets/admin-sidebar/organization.svg'
import overviewIconUrl from '@/assets/admin-sidebar/overview.svg'
import settingsIconUrl from '@/assets/admin-sidebar/settings.svg'
import statisticsIconUrl from '@/assets/admin-sidebar/statistics.svg'

function FigmaIcon({ className, src }: { className: string; src: string }) {
  return <img alt="" aria-hidden className={className} src={src} />
}

export function OverviewIcon() {
  return <FigmaIcon className="size-[14px]" src={overviewIconUrl} />
}

export function AppsIcon() {
  return <FigmaIcon className="size-[14px]" src={appsIconUrl} />
}

export function OrganizationIcon() {
  return <FigmaIcon className="size-[14px]" src={organizationIconUrl} />
}

export function ModelGatewayIcon() {
  return <FigmaIcon className="h-4 w-[14px]" src={modelGatewayIconUrl} />
}

export function AgentIcon() {
  return (
    <svg aria-hidden className="size-[15px]" fill="none" viewBox="0 0 24 24">
      <path
        d="M20.341 6.484A10 10 0 0 1 10.266 21.85M3.659 17.516A10 10 0 0 1 13.74 2.152"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.9" />
      <circle cx="19" cy="5" r="2" stroke="currentColor" strokeWidth="1.9" />
      <circle cx="5" cy="19" r="2" stroke="currentColor" strokeWidth="1.9" />
    </svg>
  )
}

export function IdentityProviderIcon() {
  return (
    <svg aria-hidden className="size-[15px]" fill="none" viewBox="0 0 24 24">
      <path
        d="M9 4h8.5A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5H9M4 12h10m-3.5-3.5L14 12l-3.5 3.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
      />
    </svg>
  )
}

export function StatisticsIcon() {
  return <FigmaIcon className="size-[14px]" src={statisticsIconUrl} />
}

export function CredentialsIcon() {
  return (
    <svg aria-hidden className="size-[15px]" fill="none" viewBox="0 0 24 24">
      <rect height="14" rx="2.5" stroke="currentColor" strokeWidth="1.9" width="18" x="3" y="5" />
      <circle cx="8" cy="11" r="2.2" stroke="currentColor" strokeWidth="1.9" />
      <path
        d="M5.5 16c.6-1.55 1.42-2.3 2.5-2.3s1.9.75 2.5 2.3m3-6H18m-4.5 4H17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.9"
      />
    </svg>
  )
}

export function SettingsIcon() {
  return <FigmaIcon className="h-[15px] w-[14px]" src={settingsIconUrl} />
}
